import { Component } from '@angular/core';

@Component({
    selector: 'app-my-tasks',
    templateUrl: './my-tasks.component.html',
    styleUrls: ['./my-tasks.component.scss'],
    standalone: false
})
export class MyTasksComponent {
}


export enum MyTaskFilter {
  ALL_TASKS,
  ASSIGNED_TO_ME,
  CREATED_BY_ME
}
